module.exports = __webpack_public_path__ + "static/media/other-bank-card.d1ee99f5.svg";